<script>
import { mapState } from "pinia";
import { useAppStore } from "@/store/app.store.ts";
import { useChatStore } from "@/store/chat.store.ts";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ChatMixin",
  computed: {
    ...mapState(useAppStore, ["dispatcher"]),
    ...mapState(useChatStore, ["threads", "chatService"]),
  },
  methods: {
    showMessageTime(dt) {
      if (!this.dispatcher) return "";
      const d = this.$dayjs.utc(dt).tz(this.dispatcher.timezone);
      const isToday = d.isSame(new Date(), "day");
      return d.format(isToday ? "HH:mm z" : "MM/DD/YY HH:mm z");
    },
    async noResponseThread() {
      try {
        const resp = await this.$api.chat.noResponseThread(this.thread.id);
        if (resp.success) {
          this.viewThread(this.thread);
        }
      } catch (err) {
        console.error("Can not set no response thread", err);
      }
    },
    async resolveThread() {
      await this.updateThread({ dispatcherId: this.dispatcher.id, resolved: true });
    },
    viewThread(thread, limit = 25, timeFrom = null) {
      if (!thread || !thread.id || !this.chatService) {
        return;
      }

      const chatStore = useChatStore();

      chatStore.setViewedThreadId(thread.id);
      this.chatService.sendMessagesUpdate(thread.id, limit, timeFrom);
    },
    async updateThread(data) {
      try {
        const resp = await this.$api.chat.updateThread(this.thread.id, data);
        if (resp.success) {
          this.viewThread(this.thread);
        }
      } catch (err) {
        console.error("Can not update thread", err);
      }
    },
  },
});
</script>
